import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataService } from '../services/data.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { MessageService } from '../services/message.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.scss'],
})
export class InvoicesComponent {
  url: string = 'invoice';
  form!: FormGroup;
  apiUrl = environment.apiUrl;

  data: Array<any> = [];
  contacts: Array<any> = [];
  items: Array<any> = [];
  id!: string;
  isLoading: boolean = false;

  resumenCards = [
    {
      label: '',
      value: 0,
      icon: 'fas fa-users',
      bgClass: 'bg-white',
      desc: 'Qu',
      route: '/numbers/accounting',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-receipt',
      bgClass: 'bg-white',
      desc: 'Tax compliance',
      route: null,
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-receipt',
      bgClass: 'bg-white',
      desc: 'Invoices',
      route: '/numbers/accounting/invoices',
    },
    /* {
      label: '',
      value: 0,
      icon: 'fas fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Bills',
      route: '/numbers/accounting/external',
    }, */
  ];

  resumenCardsTwo = [
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Finance',
      route: '/numbers',
    },
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-building-columns',
      bgClass: 'bg-white',
      desc: 'Accounting',
      route: '/numbers/accounting',
    },
  ];

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private router: Router,
    private messageService: MessageService,
    private http: HttpClient,
    private route: ActivatedRoute,
  ) {
    this.initForm();
  }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.selectDataContacts();
      this.selectDataItems();

      this.id = params['id'];

      if (this.id) {
        this.getData();
      }
    });
  }

  private initForm(): void {
    this.form = this.fb.group({
      customer_id: ['', [Validators.required]],
      company: ['', [Validators.required]],
      email: ['', [Validators.required]],
      phone: [''],
      item_id: ['', [Validators.required]],
      item_name: ['Pick-up / Drop-off Courier Service', [Validators.required]],
      rate: [0, [Validators.required]],
      description: [''],
      quantity: [1, [Validators.required]],
      tax_id: ['', [Validators.required]],
    });
  }

  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }

  onSubmit(): void {
    if (this.id) {
      this.updateData();
    } else {
      this.createData();
    }
  }

  getData(): void {
    console.log('gen invoice getData', this.id);
    this.isLoading = true;
    this.dataService.getData(`${this.url}/${this.id}`).subscribe((response) => {
      console.log('response getData', response);
      this.form.patchValue({
        customer_id: response.data.customer_id,
        item_id: response.data.line_items[0].item_id,
        quantity: response.data.line_items[0].quantity,
        rate: response.data.line_items[0].rate,
      });

      setTimeout(() => {
        this.setClientDataById(response.data.customer_id);
        this.selectDataItems();
        //this.setItemDataById(response.data.line_items[0].item_id);
        this.isLoading = false;
      }, 1000);
    });
  }

  createData() {
    console.log('gen invoice');
    this.isLoading = true;
    this.dataService.postData(`${this.url}/add`, this.form.value).subscribe({
      next: (response: any) => {
        console.log('Respuesta del servidor createInvoice: ', response);
        if (response && response.rst === true) {
          this.form.reset();
          const invoiceId = response.invoice_id;
          //const invoiceUrl = response.data.invoice.invoice_url;
          this.isLoading = false;

          const pdfUrl = `${this.apiUrl}/${this.url}/downloadInvoice/${invoiceId}`;
          window.open(pdfUrl, '_blank');

          this.router.navigateByUrl('/billing/invoices');
          /* descarga automatica */
          //this.downloadPdf(invoiceId)
        } else {
        }
      },
      error: (error) => {
        console.error('Error al crear:', error);
        // this.messageService.add('Error al crear el : ' + (error.error?.msg || error.message), 'danger');
      },
    });
  }

  updateData(): void {
    console.log('gen invoice');
    this.isLoading = true;
    this.dataService
      .putData(`${this.url}/edit/${this.id}`, this.form.value)
      .subscribe({
        next: (response: any) => {
          console.log('Respuesta del servidor update invoice: ', response);
          if (response && response.rst === true) {
            this.form.reset();
            this.router.navigateByUrl('/billing/invoices');
          } else {
          }
        },
        error: (error) => {
          console.error('Error al crear:', error);
          // this.messageService.add('Error al crear el : ' + (error.error?.msg || error.message), 'danger');
        },
      });
  }

  /* descarga automatica */
  /* downloadPdf(invoiceId: string): void {
    const url = `${this.url}/downloadInvoice/${invoiceId}`;
    
    this.http.get(url, { responseType: 'blob' }).subscribe(blob => {
      const file = new Blob([blob], { type: 'application/pdf' });
      const fileURL = window.URL.createObjectURL(file);
      
      const a = document.createElement('a');
      a.href = fileURL;
      a.download = `factura-${invoiceId}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(fileURL); // limpia la memoria
    }, error => {
      console.error("Error al descargar el PDF:", error);
    });
  } */

  selectDataContacts(): void {
    this.isLoading = true;
    this.dataService
      .getData(`${this.url}/contacts/list`)
      .subscribe((response) => {
        console.log('response.data contacts', response);
        this.contacts = response.data;
        this.isLoading = false;
      });
  }

  selectDataItems(): void {
    this.dataService.getData(`${this.url}/items/list`).subscribe((response) => {
      console.log('response.data items', response);
      this.items = response.data;
      const item_id = response.data[0].item_id;
      this.form.patchValue({
        tax_id: response.tax_id,
      });
      this.setItemDataById(item_id);
    });
  }

  onClientChange(event: Event): void {
    const selectedId = (event.target as HTMLSelectElement).value;
    console.log('ID seleccionado:', selectedId);
    this.setClientDataById(selectedId);
  }

  setClientDataById(contactId: string): void {
    console.log('setClientDataById ', contactId);
    const selectedContact = this.contacts.find(
      (contact) => contact.contact_id === contactId,
    );
    console.log('selectedContact ', selectedContact);
    if (selectedContact) {
      this.form.patchValue({
        company: selectedContact.company_name,
        email: selectedContact.email,
        phone: selectedContact.phone,
      });
    }
  }

  /* onItemChange(event: Event): void {
    const selectedId = (event.target as HTMLSelectElement).value;
    console.log('ID seleccionado:', selectedId);
    this.setItemDataById(selectedId);
  }*/

  setItemDataById(selectedId: string): void {
    console.log('setItemDataById');
    const selectedItem = this.items.find((item) => item.item_id === selectedId);
    console.log('selectedItem', selectedItem);
    console.log('form', this.form.value);

    if (selectedItem) {
      this.form.patchValue({
        item_id: selectedItem.item_id,
        //item_name: selectedItem.item_name,
        //rate: selectedItem.rate,
        //description: selectedItem.description,
      });
    }
  }
}
